import React, { useEffect, useState } from "react";
import { Box, Grid2, Skeleton, Stack, Typography } from "@mui/material";
import Detail from "../detail";
import { useSelector } from "react-redux";
import { asyncSearchList } from "../../../../../utils/httpRequests";
import { useAlertContext } from "../../../../../contexts/alert/AlertProvider";
import { isArray } from "lodash";

function Journeys() {
  const { showAlert } = useAlertContext();
  const { route } = useSelector((state: any) => state.booking);
  const token = useSelector((state: any) => state.auth.token);
  const app = useSelector((state: any) => state.app.data);
  const [loading, setLoading] = useState<boolean>(false);
  const [journeys, setJourneys] = useState<any[]>([]);

  const getJourneys = async () => {
    if (loading) return;
    setLoading(true);
    const condition = {
      page: 1,
      limit: 999999,
      q: {
        route_id: route?._id,
      },
    };
    const resp = await asyncSearchList({
      apiCode: "journeyplans",
      token,
      idApp: app?._id,
      condition,
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi tải hành trình",
      });
      setLoading(false);
      return;
    }
    setJourneys(resp?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    if (!!route) {
      getJourneys();
    } else {
      setJourneys([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route]);

  return (
    <Box>
      {loading ? (
        <Stack>
          <Skeleton
            variant="rounded"
            animation="wave"
            sx={{ width: "100%", height: "45px" }}
          />
        </Stack>
      ) : (
        <Grid2 container spacing={1}>
          {isArray(journeys) && journeys?.length > 0 ? (
            journeys.map((journey) => {
              return (
                <Grid2 key={journey._id} size={{ xs: 6, md: 4 }}>
                  <Detail data={journey} />
                </Grid2>
              );
            })
          ) : (
            <Typography
              sx={{ width: "100%", textAlign: "center", fontStyle: "italic" }}
            >
              Tuyến đường chưa có lịch chạy
            </Typography>
          )}
        </Grid2>
      )}
    </Box>
  );
}

export default Journeys;
